export const appConfig = {
  SERVER_URL: 'https://wharf-api.onitsoft.com/v1',
}
